















































































































































import { Component, Vue } from 'vue-property-decorator';
import {
  Action, Mutation, State, Getter, namespace,
} from 'vuex-class';
import {
  Button, Message, Radio, RadioGroup, Scrollbar, Dialog,
} from 'element-ui';
import NProgress from 'nprogress';
import Read from '@/servers/modules/read/read'; // server
import moment from 'moment';
import { isOpenAnswer } from '@/plugins/util'

@Component({
  components: {
    Button,
    Radio,
    RadioGroup,
    Scrollbar,
    Dialog,
  },
})
export default class extends Vue {
  // ========================common
  // 区分学习页与结果页
  private showResult:boolean = false;

  private isOpenAnswer: boolean = isOpenAnswer()

  // ========================学习页
  // ------------------------顶部展示及操作
  // loading
  @Getter public skeleton: any;

  @Mutation public setSkeletonDescribe:any;

  // 课程单元
  private courseUnit:string = '';

  // 文章标题
  private articleTitle:string = '';

  // 进度
  private progress:string = '';

  // 倒计时
  private questionTime:any = ''

  // 倒计时-当前时间
  private startTime: any = '';

  // 倒计时-答题限定时间
  private endTime: any = '';

  // 定时器
  private timer:any

  // ------------------------答题
  // 是否能选择
  private isDis:boolean = false;


  // ========================学习结果页
  // ------------------------顶部展示及操作
  // 进度
  private progressStart:string = '';

  private progressEnd:string = '';

  // 是否是挑战
  private isChallage:boolean = false;

  // 轮播图数据
  private swiperArr: any = [];

  // 当前要学习或重修的单元
  private startObj:any = {};

        // 记录当前学习进度
        private catId:any = '';

        // top
        private topTitle:any = '结果';

        // button
        private buttonTitle:any = '';

        // 题目
        private topic:any = [];

        // 文章
        private article:any = '';

        // 文章词汇个数
        private wordsNumber:any = [];


        // 答案
        private answer:any=[];

        // 选择
        private ind:any = ['0'];

        private ac:any = null;

        private ob:any = {};

        // 计算已经答题数
        private answerNumber:number;

        // 是否已经提交答案
        private isSubmit = false;

        // 答题结束显示结果
        private result:any={};

        // 是否点击提交
        private submitAgain:boolean=false;

        private back() {
          this.$router.push('/read')
        }

        private created() {
          console.log(this.$route.query.ids);
          this.setSkeletonDescribe(true);
          NProgress.start();
          this.init();
        }

        // 加载页面的方法（是对战）
        private challage() {
          this.catId = window.LS.get('readUnitData').catId;
          if (window.LS.get('readUnitData').unitReadStudyVos[this.catId].discontinuity !== 1) {
            this.catId = this.catId + 1;
          }
          if (this.catId < window.LS.get('readUnitData').unitReadStudyVos.length) {
            this.loadData();
          } else {
            console.log(window.LS.get('readUnitData'));
            // this.reload();
          }
        }

        // 加载页面的方法（不是对战）
        private init() {
          const form:any = {};
          if (this.$route.query.ids) {
            form.unitId = this.$route.query.ids;
          } else if (this.$route.query.type) {
            this.isChallage = true;
            form.contestId = this.$route.query.type;
          } else {
            this.$router.go(-1);
          }
          console.log(form);
          this.gotoStudyReadUnit(form).then((res: any) => {
            window.LS.set('readUnitData', res.data.data);
            // 某个部分
            this.catId = window.LS.get('readUnitData').catId;

            if (window.LS.get('readUnitData').unitReadStudyVos[this.catId].discontinuity !== 1) {
              this.catId = this.catId + 1;
            }
            if (this.catId < window.LS.get('readUnitData').unitReadStudyVos.length) {
              this.loadData();
            } else {
              console.log(window.LS.get('readUnitData'));
              // this.reload();
            }
          }).catch((e) => {
            this.$router.go(-1);
          });
        }

        // 加载页面数据
        private loadData() {
          const readUnitData = window.LS.get('readUnitData');
          // 阶段
          this.topTitle = readUnitData.unitReadStudyVos[this.catId].questionTypeName;
          // 课程单元
          this.courseUnit = readUnitData.unitReadStudyVos[this.catId].unitName;
          // 文章标题
          this.articleTitle = readUnitData.unitReadStudyVos[this.catId].articleName || '<无标题>';
          // 学习进度及重修
          this.progress = readUnitData.show;
          this.progressStart = readUnitData.current;
          this.progressEnd = readUnitData.total;
          // 题目
          const topic = readUnitData.unitReadStudyVos[this.catId].questionVos;
          this.wordsNumber = readUnitData.unitReadStudyVos[this.catId].articleContentWordLength;
          this.questionTime = '00:00';
          if (this.catId > 0) {
            this.buttonTitle = '开始阅读与答题';
          } else {
            this.isDis = true;
            this.buttonTitle = '提交答案查看结果';
          }
          // 文章
          // 热身
          if (readUnitData.unitReadStudyVos[this.catId].showDoc == 0) {
            if (readUnitData.unitReadStudyVos[this.catId].questionVos[0].questionImg) {
              const src = readUnitData.unitReadStudyVos[this.catId].questionVos[0].questionImg;
              this.article += `<img style="width:300px;margin: 20px auto;display:block" src="${src}" alt="">`;
            } else {
              // const src = require('@/assets/images/ui-word/word-question-default.png')
              // this.article += `<img style="width:300px;margin: 20px auto;display:block" src="${src}" alt="">`;
            }
          } else if (this.catId == 0) {
            this.article = readUnitData.unitReadStudyVos[this.catId].articleContent;
          } else {
            this.article = '<div style="width:calc(100% - 80px);height:300px;text-align:center;line-height:300px;background:#F9FBFE;margin: 0 auto;">请快速查看题目</div>';
          }
          // 初始化--答案
          const thisData = readUnitData.unitReadStudyVos[this.catId];
          for (const i in topic) {
            const obj = {
              beginTime: new Date().getTime(),
              catId: thisData.questionType,
              contestId: thisData.contestId == null ? '' : thisData.contestId, // 返回值有就传递没有就不传递
              courseId: thisData.courseId,
              docId: thisData.docId,
              endTime: 0,
              qestionId: topic[i].questionId,
              qestionOptionId: topic[i].historyRightOrWrong !== 0 ? topic[i].rightId : '',
              unitId: thisData.unitId,
            };
              // 存放 选项集合
            const questionOption = topic[i].questionOptionVos;
            console.log('topic', topic[i].historyRightOrWrong);

            if (topic[i].historyRightOrWrong !== 0) {
              // 赋值正确的答案
              topic[i].selected = topic[i].rightId;
              // 在基础上 做限制 判断是哪个未正确答案
              for (let j = 0; j < questionOption.length; j++) {
                // 初始化所有答案
                topic[i].questionOptionVos[j].image = '';
                // 给唯一选项赋值 正确答案
                if (questionOption[j].optionid == topic[i].rightId) {
                  topic[i].questionOptionVos[j].image = require('../../assets/images/new-read/study-chose-right.png');
                }
              }
              console.log(topic[i].questionOptionVos);
            }
            this.answer.push(obj);
          }
          this.topic = topic;
          // 强制更新渲染
          this.$forceUpdate();
          NProgress.done();
          this.setSkeletonDescribe(false);
        }

        // 重新加载页面
        private reload() {
          this.loadData();
          return false;
          const readUnitData = window.LS.get('readUnitData');
          console.log(this.catId);
          console.log(readUnitData);
          this.topTitle = readUnitData.unitReadStudyVos[this.catId].questionTypeName;
          // 题目
          const topic = readUnitData.unitReadStudyVos[this.catId].questionVos;
          this.wordsNumber = readUnitData.unitReadStudyVos[this.catId].articleContentWordLength;
          this.questionTime = '00:00';
          if (this.catId > 0) {
            this.buttonTitle = '开始阅读与答题';
          } else {
            this.isDis = true;
            this.buttonTitle = '提交答案查看结果';
          }
          // 文章
          if (readUnitData.unitReadStudyVos[this.catId].showDoc == 0) {
            console.log(readUnitData.unitReadStudyVos[this.catId].questionVos[0].questionImg);
            this.article = '这是<热身>题，不需要显示文章内容，请根据常识或图片作出选择。';
            if (readUnitData.unitReadStudyVos[this.catId].questionVos[0].questionImg) {
              const src = readUnitData.unitReadStudyVos[this.catId].questionVos[0].questionImg;
              this.article += `<br /><img src="${src}" alt="">`;
            }
          } else if (this.catId == 0) {
            this.article = readUnitData.unitReadStudyVos[this.catId].articleContent;
          } else {
            this.article = '请快速查看题目';
          }
          // 初始化--答案
          const thisData = readUnitData.unitReadStudyVos[this.catId];
          for (const i in topic) {
            const obj = {
              beginTime: new Date().getTime(),
              catId: thisData.questionType,
              contestId: thisData.contestId == null ? '' : thisData.contestId, // 返回值有就传递没有就不传递
              courseId: thisData.courseId,
              docId: thisData.docId,
              endTime: 0,
              qestionId: topic[i].questionId,
              qestionOptionId: topic[i].historyRightOrWrong !== 0 ? topic[i].rightId : '',
              unitId: thisData.unitId,
            };
              // 存放 选项集合
            const questionOption = topic[i].questionOptionVos;
            console.log('topic', topic[i].historyRightOrWrong);

            if (topic[i].historyRightOrWrong !== 0) {
              // 赋值正确的答案
              topic[i].selected = topic[i].rightId;
              // 在基础上 做限制 判断是哪个未正确答案
              for (let j = 0; j < questionOption.length; j++) {
                // 初始化所有答案
                topic[i].questionOptionVos[j].image = '';
                // 给唯一选项赋值 正确答案
                if (questionOption[j].optionid == topic[i].rightId) {
                  topic[i].questionOptionVos[j].image = require('../../assets/images/new-read/study-chose-right.png');
                }
              }
              console.log(topic[i].questionOptionVos);
            }
            this.answer.push(obj);
          }
          this.topic = topic;
          // 强制更新渲染
          this.$forceUpdate();
          NProgress.done();
          this.setSkeletonDescribe(false);
        }

        // 加载页面数据--请求数据
        private async gotoStudyReadUnit(data) {
          return await Read.gotoStudyReadUnit(data);
        }

        // 选择答案
        private changeAnswer(data, index, indexs, preData) {
          console.log(data);
          console.log(index);
          console.log(indexs);
          console.log(preData);
          this.answer[index].qestionOptionId = data.optionid;
          console.log(preData);
          if (preData != 'none') {
            this.ac = index;
            if (this.ac == index) {
              this.ind.splice(index, 1, data.optionid);
            } else {
              this.ind.push(data.optionid);
            }
            this.ob = { ...this.ind };
            console.log(this.ob);
          } else {
            data.selected = '';
          }
          this.$forceUpdate();
          console.log(this.topic);
        }

        // 计算已经答题数
        private getAnswerNumber() {
          console.log('提交');
          let j = 0;
          for (const i in this.answer) {
            if (this.answer[i].qestionOptionId != '') {
              console.log(this.topic);
              console.log(this.answer[i]);
              j++;
            }
          }
          this.answerNumber = j;
          console.log(j);
        }

        // 提交答案
        private submintAnswer(a) {
          const readUnitData = window.LS.get('readUnitData');// - 获取此文章的四纵类型题，热身，速读，查读，推论等
          if (!this.submitAgain) {
            let isEnd = true;
            if (this.catId > 0 && this.buttonTitle.indexOf('阅读') > -1) { // - 不是第一题并且按钮内有阅读
              console.log('mmmm');
              isEnd = false;
              this.buttonTitle = '提交答案查看结果'; // - 将提交按钮变成‘提交答案查看结果’
              this.article = readUnitData.unitReadStudyVos[this.catId].articleContent;// - 将左边的文章显示出来（给它赋值）
              // 定时器 开始时间
              console.log(1);
              // this.questionTime = readUnitData.unitReadStudyVos[this.catId].questionTime
              // 开始计时
              this.startTime = moment();
              this.endTime = moment().add(readUnitData.unitReadStudyVos[this.catId].questionTime, 'seconds');
              this.timer = setInterval(() => {
                // this.nowTime = moment().unix();
                this.questionTime = this.countDown();
                this.startTime = moment();
              }, 1000);
              this.isDis = true;
            }
            if (this.buttonTitle.indexOf('继续答题') > -1) { // - 如果按钮是继续答题
              isEnd = false;
              this.isSubmit = false;
              this.setSkeletonDescribe(true);
              NProgress.start();
              this.catId = this.catId + 1;
              this.buttonTitle = '开始阅读与答题';
              this.answer = [];
              this.reload();
            }
            if (this.buttonTitle == '查看结果') { // - 如果是查看结果
              isEnd = false;
              this.showResult = true;
              this.topTitle = '结果';
              console.log(this.result);
            }
            if (isEnd) {
              this.getAnswerNumber();
              if (this.answerNumber < this.topic.length) {
                $alert('<p style="padding: 0 10px;">请做完所有题目再提交!</p>', 3000, { background: 'rgba(255, 102, 102, .8)', width: '260px' });
              } else {
                clearTimeout(this.timer);
                for (const i in this.answer) {
                  this.answer[i].endTime = new Date().getTime();
                  if (this.isChallage) {
                    this.answer[i].contestId = this.$route.query.type;
                  }
                }
                console.log(this.answer);
                this.submitAgain = true;
                // 防止再次提交
                this.saveOption().then((res: any) => {
                  this.submitAgain = false;
                  console.log(`xianzai=====>${this.catId}`);
                  this.isDis = false;
                  console.log(readUnitData.unitReadStudyVos);
                  if (this.catId == (readUnitData.unitReadStudyVos.length - 1)) {
                    console.log('最后一题');
                    this.result = res.data.data;
                    this.isSubmit = true;
                    this.buttonTitle = '查看结果';
                  } else {
                    console.log(res);
                    this.isSubmit = true;
                    this.buttonTitle = '继续答题';
                  }
                }).catch((e:any) => {
                  this.submitAgain = false;
                  console.log(e);
                });
              }
            }
          } else {
            $alert("<p style='padding: 0 10px;'>提交数据中</p>");
          }
        }

        // 保存答案
        private async saveOption() {
          return await Read.saveOption(this.answer);
        }

        // 退出
        private resultBtn(type:number) {
          switch (type) {
            case 0:
              this.$router.go(-1);
              break;
            case 1:
              if (this.result.rebuildUnitId) {
                this.$router.replace({
                  path: '/read/study',
                  query: {
                    ids: this.result.rebuildUnitId,
                    time: new Date().getTime(),
                  },
                });
                window.location.reload()
              }
              break;
            case 2:
              if (this.result.nextUnitId && this.result.nextUnitId !== null) {
                console.log('nextUnitId!=空');
                this.$router.replace({ path: '/read/study', query: { ids: this.result.nextUnitId } });
                window.location.reload()
              } else {
                if (this.$route.query.type) {
                  this.swiperArr = window.LS.get('readData').redReadIndexUnitsVos;
                  // 学习中
                  const studyArr1 = [];
                  // 重修
                  const studyArr2 = [];
                  for (const i in this.swiperArr) {
                    if (this.swiperArr[i].status == 1) {
                      studyArr1.push(this.swiperArr[i]);
                    } else if (this.swiperArr[i].status == 4 || this.swiperArr[i].status == 8) {
                      studyArr2.push(this.swiperArr[i]);
                    }
                  }
                  if (studyArr1.length > 0) {
                    this.startObj = studyArr1[0];
                  } else {
                    this.startObj = studyArr2[0];
                  }
                  this.$router.replace({ path: '/read/study', query: { ids: this.startObj.unitId } });
                }
                console.log('nextUnitId==空','electron');
                window.location.reload()
              }
              break;
          }
        }

        private updated() {
          // console.log(this.$route.query);
        }

        // 倒计时
        private get countDown() {
          return () => {
            const m1: any = this.startTime;
            const m2: any = this.endTime;
            const du = moment.duration(m2 - m1, 'ms');
            const mins = du.get('minutes');
            const ss = du.get('seconds');
            if (mins <= 0 && ss <= 0) {
              clearTimeout(this.timer);
              this.article = '<div style="calc(100% - 80px);height:300px;text-align:center;line-height:300px;background:#F9FBFE;margin: 0 auto;">阅读时间已结束</div>';
              return '00:00';
            }
            return `${this.PrefixInteger(mins, 2)}:${this.PrefixInteger(ss, 2)}`;
          };
        }

        private PrefixInteger(num: any, n: any) {
          return (Array(n).join('0') + num).slice(-n);
        }

        // 放大缩小字体
        private reSize : any = { fontSize: 18, lageColor: '#333333', smallColor: '#333333' };

        private reSizeFun(type:string) {
          const _this = this;
          // 初始化颜色
          this.reSize.lageColor = this.reSize.smallColor = '#333333';
          if (type == 'small') {
            this.reSize.fontSize = this.reSize.fontSize - 2; reSize();
          }
          if (type == 'lage') {
            this.reSize.fontSize = this.reSize.fontSize + 2; reSize();
          }
          function reSize() {
            if (_this.reSize.fontSize <= 14) {
              _this.reSize.fontSize = 14;
              _this.reSize.smallColor = '#B4B4B4';
            }
            if (_this.reSize.fontSize >= 22) {
              _this.reSize.fontSize = 22;
              _this.reSize.lageColor = '#B4B4B4';
            }
          }
        }

        // 弹窗
        private dialogHandle() {

        }

        // 销毁
        private destroy() {
          clearTimeout(this.timer);
          window.LS.clear('readUnitData');
        }
}
